import RecaptchaWrapper from "./recaptcha-wrapper";
import ReCAPTCHA from "./recaptcha";
export default RecaptchaWrapper;
export { ReCAPTCHA };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-recaptcha/lib/esm/index.js
// module id = 1107
// module chunks = 8